import EmplacementsTab from "@features/stock/components/EmplacementsTab";
import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardCheck } from "lucide-react";

export const Route = createFileRoute("/_app/stock/emplacements")({
  staticData: {
    title: "Emplacements",
    icon: ClipboardCheck,
    tab_icon: ClipboardCheck,
    permission: "stock.emplacements.view",
    module: "stock",
    section: "Stock",
    order: 47.5,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission("stock.emplacements.view"),
  component: EmplacementsTab,
});
